'use client'

import cn from 'clsx'
import { useEffect, useState } from 'react'
import { Button } from '~/components/button'
import { Image } from '~/components/image'
import SmileSVG from '~/public/svg/smile.svg'

const data = [
  {
    _uid: '6f5e2c02-bdf3-4c0a-915b-41dcb7fd7bb8',
    media: [
      {
        filename: '/images/card-1.webp',
        alt: 'Only for CEOs',
      },
      {
        filename: '/images/card-2.webp',
        alt: 'Only for designers',
      },
      {
        filename: '/images/card-3.webp',
        alt: 'Only for designers',
      },
    ],
    title: 'Cora gets to know you, automatically',
    body: 'Cora reads your email patterns to discover who you are—your work, your style, and your priorities.',
  },
  {
    _uid: 'f2d0c6e0-2e58-4f69-9c0b-d9b0e91a49b3',
    media: {
      filename: '/videos/demo.mp4',
      alt: 'Only for designers',
    },
    title: 'Shape Cora through conversation',
    body: 'Talk to Cora like your chief of staff over chat or email. Explain how you want emails filed and situations handled. It remembers everything that matters.',
  },
]

function MediaTicker({ media = [] }) {
  const [count, setCount] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((count) => (count + 1) % media?.length)
    }, 1000)
    return () => clearInterval(interval)
  }, [media?.length])

  return (
    <div className="relative w-full h-full">
      {media?.map((item, index) => (
        <Image
          key={item?.filename}
          src={item?.filename}
          alt={item?.alt}
          fill
          style={{
            opacity: count === index ? 1 : 0,
          }}
        />
      ))}
    </div>
  )
}

export function Features({ className }) {
  return (
    <section
      className={cn(
        'relative flex dr-gap-24 flex-col items-center justify-center dr-mt-108',
        className
      )}
    >
      <div className="dr-px-40 dt:dr-px-0">
        <SmileSVG className="dr-w-42 dt:dr-w-35 flex mx-auto" />
        <h2 className="h3 text-center">Cora learns you inside and out</h2>
      </div>

      <ul className="dr-w-357 dt:dr-w-678 flex flex-col dt:flex-row dr-gap-16">
        {data?.map((card) => (
          <li
            key={card?._uid}
            className="bg-white dt:dr-w-331 dr-p-8 dr-pb-20 flex flex-col dr-gap-20 dr-rounded-24"
          >
            <picture className="relative dr-w-337 dt:dr-w-315 dr-h-360 dt:dr-h-337 overflow-hidden dr-rounded-16">
              {card?.media?.filename?.includes('.mp4') && (
                <video
                  src={card?.media?.filename}
                  autoPlay
                  muted
                  loop
                  className="w-full h-full object-cover"
                />
              )}
              {card?.media?.length > 0 && <MediaTicker media={card?.media} />}
            </picture>
            <div className="dr-px-20 dt:dr-px-0 dt:dr-w-271 mx-auto flex flex-col dr-gap-8">
              <p className="p-xl text-[#1D1B20]">{card?.title}</p>
              <p className="p text-[#A1A1A1]">{card?.body}</p>
            </div>
          </li>
        ))}
      </ul>

      <Button
        label="Get started"
        className="desktop-only"
        href="https://cora.computer/users/sign_up"
      />
    </section>
  )
}
